import escape from 'lodash/escape';
import isNil from 'lodash/isNil';
import moment from 'moment-timezone';
import EnvironmentUtils from '@spothero/utils/environment';
import Config from 'config';
import FormatUtils from 'utils/format';

export const BranchUtils = branch => ({
    init(key, cb) {
        if (!branch) {
            return;
        }

        branch.init(key, cb);
    },

    generateDeepLinkParams({
        latitude,
        longitude,
        searchString = null,
        place = null,
        starts = null,
        ends = null,
    }) {
        let deepLinkParams = `?latitude=${latitude}&longitude=${longitude}`;

        if (searchString) {
            deepLinkParams = `${deepLinkParams}&search_string=${escape(
                searchString
            )}`;
        }

        if (starts && ends) {
            const newStarts = !moment.isMoment(starts)
                ? moment(starts).format(Config.apiDateTimeFormat)
                : starts.format(Config.apiDateTimeFormat);
            const newEnds = !moment.isMoment(ends)
                ? moment(ends).format(Config.apiDateTimeFormat)
                : ends.format(Config.apiDateTimeFormat);

            deepLinkParams = `${deepLinkParams}&starts=${newStarts}&ends=${newEnds}`;
        }

        if (place) {
            const {
                google_places_place_id: placesPlaceId,
                google_places_id: placesId,
                google_places_name: placesName,
                google_places_reference: placesReference,
            } = place;

            if (!isNil(placesPlaceId)) {
                deepLinkParams = `${deepLinkParams}&places_place_id=${placesPlaceId}`;
            }

            if (!isNil(placesId)) {
                deepLinkParams = `${deepLinkParams}&places_id=${placesId}`;
            }

            if (!isNil(placesName)) {
                deepLinkParams = `${deepLinkParams}&places_name=${placesName}`;
            }

            if (!isNil(placesReference)) {
                deepLinkParams = `${deepLinkParams}&places_reference=${placesReference}`;
            }
        }

        return deepLinkParams;
    },

    generateDeepLink({
        latitude,
        longitude,
        searchString = null,
        place = null,
        starts = null,
        ends = null,
    }) {
        return `${Config.siteUrl}/search${this.generateDeepLinkParams({
            latitude,
            longitude,
            searchString,
            place,
            starts,
            ends,
        })}`;
    },

    link(data, callback) {
        if (!branch) {
            return;
        }

        branch.link(data, callback);
    },

    setViewData(data) {
        if (!branch) {
            return;
        }

        branch.setBranchViewData(data);
    },

    trackCommerceEvent({transactionId, price, currency}) {
        if (!branch) {
            return;
        }
        const {displayPrice} = FormatUtils.price(price);

        branch.trackCommerceEvent('purchase', {
            transaction_id: String(transactionId), // eslint-disable-line camelcase
            revenue: displayPrice,
            currency: currency.toUpperCase(),
        });
    },
});

export default BranchUtils(
    EnvironmentUtils.isBrowser() ? require('branch-sdk') : null
);
